import React, { useRef } from 'react';
import { makeStyles } from '~/UIKit/Style';
import { useTranslation } from 'react-i18next';
import { ConfirmationModal, ItemCreation, ItemCreationWrapper } from '~/Components';
import { useMerchantModalActions } from './useMerchantModalActions';
import { CreateMerchantTabSelector } from './CreateMerchantTabSelector';
import { useCreateMerchantForm } from './useCreateMerchantForm';
import { IMerchant, initialValues } from '~/Models/DTO/Merchant.models';
import { useMediaQuery, useTheme } from '@mui/material';
import { Typography } from '~/UIKit';
const useStyles = makeStyles((theme) => ({
  itemContainer: {
    display: 'block',
    overflow: 'auto',
    padding: '24px 0 58px',
    overflowY: 'auto scroll',
    overflowX: 'none',
    [theme.breakpoints.up('md')]: {
      padding: '24px 16px 58px',
    },
    '&::-webkit-scrollbar': {
      width: 8,
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'rgba(0, 0, 0, 0.1)',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
      borderRadius: 10 /* Scrollbar roundness */,
    },
  },

  modalNote: {
    [theme.breakpoints.up('md')]: {
      padding: '0 0 50px 0',
    },
    padding: '0 16px 50px',
    display: 'block',
    textAlign: 'justify',
  },
  stepContainer: {
    [theme.breakpoints.up('md')]: {
      padding: '0 0 50px 0',
    },
    padding: '0 16px 50px',
  },
}));
interface ICreateMerchantProps {
  open?: boolean;
  setOpen?: (open: boolean) => void;
  merchantList?: IMerchant[];
}
export const CreateMerchant = ({
  open = false,
  setOpen = () => {},
  merchantList = [] as IMerchant[],
}: ICreateMerchantProps) => {
  const myDivRef = useRef(null);
  const { classes } = useStyles();
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { cancel, confirm, tab, closeAction, validation, onSave } = useMerchantModalActions({
    setOpen,
    merchant: initialValues,
    myDivRef,
  });
  const { sections } = useCreateMerchantForm({ activeStep: tab });
  const initialDate =
    merchantList?.find(({ merchantDataComplete }) => !merchantDataComplete) || initialValues;
  return (
    <ConfirmationModal
      open={open}
      title={t('merchantForm.modal.title')}
      cancel={cancel}
      confirm={confirm}
      closeAction={closeAction}
      type={isMobile ? 'vertical' : 'horizontal'}
      rawContent
      hideCloseIcon
    >
      <div className={classes.itemContainer} data-testid="CreateMerchant" ref={myDivRef}>
        {tab === 0 && (
          <Typography
            className={classes.modalNote}
            dangerouslySetInnerHTML={{ __html: t('merchantForm.modal.note') }}
          />
        )}
        <div className={classes.stepContainer}>
          <CreateMerchantTabSelector activeStep={tab} isMobile={isMobile} />
        </div>
        <ItemCreationWrapper>
          <ItemCreation<IMerchant>
            listItems={sections}
            headers={[]}
            onSave={onSave}
            initialValues={initialDate}
            validate={validation}
            isLoading={false}
            networkError={undefined}
            validateOnMount
            disableMobile
            skipConfirmationModal
          />
        </ItemCreationWrapper>
      </div>
    </ConfirmationModal>
  );
};
